export default __webpack_public_path__ + "d0506847740d94ce9e33e48c6ca99728.svg";